import { createClient, SupabaseClient } from "@supabase/supabase-js";

// Clients Supabase para o realtime. São DOIS projetos:
//  - "chat": banco CHAT (tabelas chats, contatos) — prefixo localStorage `supabase_`
//  - "crm" : banco CRM  (tabela funil_fluxo/leads) — prefixo `supabase_crm_`
// URL e anon key (públicas) + token (JWT por tenant, secret próprio de cada projeto)
// vêm do /login. O token define role=authenticated + claims que as policies RLS usam.
type Scope = "chat" | "crm";
const _clients: Record<string, { client: SupabaseClient; token: string }> = {};

function makeClient(scope: Scope): SupabaseClient | null {
  const p = scope === "crm" ? "supabase_crm_" : "supabase_";
  const url = localStorage.getItem(p + "url");
  const anon = localStorage.getItem(p + "anon_key");
  const token = localStorage.getItem(p + "token");
  if (!url || !anon || !token) return null;

  let entry = _clients[scope];
  if (!entry) {
    const client = createClient(url, anon, {
      auth: { persistSession: false, autoRefreshToken: false },
      realtime: { params: { eventsPerSecond: 10 } },
    });
    entry = _clients[scope] = { client, token: "" };
  }
  if (entry.token !== token) {
    entry.client.realtime.setAuth(token);
    entry.token = token;
  }
  return entry.client;
}

export const getSupabaseRealtime = () => makeClient("chat");
export const getSupabaseRealtimeCRM = () => makeClient("crm");
